import { call, put, select, takeLatest } from 'redux-saga/effects'
import { MotorSensoryAssessmentConstants } from '../store/motoSensoryAssessment.constants'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getMotorSensoryAssessmentSelector } from '../selectors/motorSensoryAssessment.selector'
import { getServiceIdSelector } from '../../../../user/selectors'
import { IMotorSensoryAssessmentState } from '../store/motoSensoryAssessment.types'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { setMotorSensoryResponse } from '../store/motoSensoryAssessment.actions'
import { initialMotorSensoryAssessmentState } from '../store/motoSensoryAssessment.reducers'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* saveMotorSensory() {
  const motorSensoryAssessment: IMotorSensoryAssessmentState = yield select(getMotorSensoryAssessmentSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const motorSensoryAssessmentObject = getSelectedDataFromObject(
      motorSensoryAssessment,
      Object.keys(initialMotorSensoryAssessmentState)
    )
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...motorSensoryAssessmentObject,
      },
    }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setMotorSensoryResponse(response))
    } catch (e) {
      yield put(throwPcrException(`saveMotorSensory() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveMotorSensorySaga() {
  yield takeLatest([MotorSensoryAssessmentConstants.SAVE_MOTOR_SENSORY], performWithMutexHOG, saveMotorSensory)
}
